import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const SoftwareDevelopmentJobsNoida = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Software Development Jobs in Noida | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest Software Development Jobs in Noida NCR. Explore openings for Java, Python, React, and Full Stack Developers. Apply today on JobsInDelhiNCR."
        />
        <meta
          name="keywords"
          content="software development jobs in Noida, software engineer jobs in Noida, software developer jobs Noida NCR, IT jobs in Noida, full stack developer jobs Noida, java developer jobs Noida, python developer jobs Noida, c++ developer jobs Noida, fresher software jobs Noida, software company jobs Noida NCR"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/softwaredevelopment-jobs-in-noida"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Software Development Jobs in Noida – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Searching for the latest <strong>Software Development Jobs in Noida NCR</strong>? Whether you’re skilled in Java, Python, C++, or web technologies, explore verified job opportunities from top IT companies and startups hiring software developers in Noida NCR.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Software Developers in Noida
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Infosys</li>
          <li>Accenture</li>
          <li>HCL Technologies</li>
          <li>Wipro</li>
          <li>Tech Mahindra</li>
          <li>TCS</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular Software Development Roles in Noida NCR
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Software Engineer Jobs in Noida</li>
          <li>Full Stack Developer Jobs in Noida</li>
          <li>Backend Developer Jobs in Noida</li>
          <li>Frontend Developer Jobs in Noida</li>
          <li>Java Developer Jobs in Noida</li>
          <li>Python Developer Jobs in Noida</li>
          <li>C++ Developer Jobs in Noida</li>
          <li>React Developer Jobs in Noida</li>
          <li>Angular Developer Jobs in Noida</li>
          <li>Software Tester Jobs in Noida</li>
        </ul>

        <p className="text-gray-600">
          Begin your software career journey with <strong>jobsindelhincr.in</strong> — your reliable job portal to find verified <strong>Software Development Jobs in Noida NCR</strong>. Apply directly without registration and connect with top employers across the region.
        </p>
      </div>

      <Footer />
    </>
  );
};

export default SoftwareDevelopmentJobsNoida;
